export default "__VITE_PUBLIC_ASSET__57fcae53__"